import { render, staticRenderFns } from "./captureConfigModal.vue?vue&type=template&id=7ff4ace6&scoped=true"
import script from "./captureConfigModal.vue?vue&type=script&lang=js"
export * from "./captureConfigModal.vue?vue&type=script&lang=js"
import style0 from "./captureConfigModal.vue?vue&type=style&index=0&id=7ff4ace6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4ace6",
  null
  
)

export default component.exports